/* eslint-disable */
import React, { useState, useEffect } from 'react';
import jwt_decode from "jwt-decode";
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import Modal from '../../../../ReusableTable/DssModel/DssModel';
import { MESSAGE_TYPE } from '../../../../../constants';
import ColumnSelector from '../../../../ReusableTable/DssColumnSelectionModal/ColumnSelectionModal';
import './TableForTDS.css';
import swal from 'sweetalert';
import config from '../../../../../config/config';
import { usePopupManager } from '../../../../../providers/PopupManager/PopupManager';
import HtmlComp from '../../../../ReusableTable/DssHtmlComp/DssHtmlComp';

const { API_BASE_URL } = config;

const TableForTDS = ({ data, columns, itemsPerPage, onPageChange, isCustomOpen, totalRecords, handleCSVDownload, dataLoading }) => {
    const { showPopup } = usePopupManager();
    const [currentPage, setCurrentPage] = useState(0);
    const [currentData, setCurrentData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedColumns, setSelectedColumns] = useState(columns.map(col => col.accessor || col.header));
    const [selectedRows, setSelectedRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);

    const UserToken = keycloak.token;
    let username = '';
    let Email = '';

    if (UserToken) {
        const decoded = jwt_decode(UserToken);
        username = decoded.preferred_username;
        Email = decoded.email;
    }

    useEffect(() => {
        const offset = currentPage * itemsPerPage;
        setCurrentData(data);
        setSelectedRows(selectedRows.filter(rowId =>
            data.slice(offset, offset + itemsPerPage).some(row => row.id === rowId)
        ));
    }, [currentPage, data, itemsPerPage]);

    const handlePageClick = ({ selected }) => {
        setCurrentPage(selected);
        onPageChange(selected + 1);
    };

    const fileCountClicked = (buttonValue) => {
        const formdata = new FormData();
        formdata.append('selectedIndex', sessionStorage.getItem("SelectedFolderFile"));
        formdata.append("file_name", buttonValue);
        formdata.append("useremail", Email);

        const configReq = {
            method: 'post',
            url: `${API_BASE_URL}/api/store-process-download-web-count`,
            headers: {
                'Authorization': 'Basic YWRtaW4xOjEyMw==',
            },
            data: formdata
        };

        axios(configReq).then(function (response) {
            const fileNotDownloadedList = response.data.file_not_download_list;
            if (fileNotDownloadedList.length !== 0) {
                let tableRows = fileNotDownloadedList.map(file => `<tr><td>${file}</td></tr>`).join('');
                let message = `
                    Bulk download limit reached. Please check the file not downloaded list:
                    <table border="1">
                        <tr><th>File Not Downloaded</th></tr>
                        ${tableRows}
                    </table>
                `;
                showPopup({
                    type: MESSAGE_TYPE.INFORMATION,
                    contextText: MESSAGE_TYPE.INFORMATION,
                    info: <HtmlComp htmlString={message} />,
                });
            }
        });
    }

    const handleDownload = () => {
        if (selectedRows.length === 0) {
            swal("Select columns", "Please select any one column from table to download ", 'warning');
        } else {
            fileCountClicked(selectedRows);
            setLoading(true);
            setProgress(0);
            const formdata = new FormData();
            formdata.append('selectedIndex', sessionStorage.getItem("SelectedFolderFile"));
            formdata.append("file_name", selectedRows);

            const configReq = {
                method: 'post',
                url: `${API_BASE_URL}/api/store-process-download-web`,
                headers: { 'Authorization': 'Basic YWRtaW4xOjEyMw==' },
                data: formdata,
                responseType: 'blob',
                onDownloadProgress: (progressEvent) => {
                    if (progressEvent.lengthComputable) {
                        const total = progressEvent.total;
                        const current = progressEvent.loaded;
                        setProgress(Math.round((current / total) * 100));
                    }
                },
            };

            axios(configReq).then(function (response) {
                const blob = new Blob([response.data], { type: 'application/zip' });
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = 'files.zip';
                document.body.appendChild(link);
                link.click();
                setTimeout(() => {
                    window.URL.revokeObjectURL(downloadUrl);
                    document.body.removeChild(link);
                }, 100);
                setLoading(false);
            });
        }
    };

    const handleColumnChange = (newSelectedColumns) => {
        setSelectedColumns(newSelectedColumns);
        setIsModalOpen(false);
    };

    const handleRowSelect = (id) => {
        setSelectedRows(prevSelectedRows =>
            prevSelectedRows.includes(id)
                ? prevSelectedRows.filter(rowId => rowId !== id)
                : [...prevSelectedRows, id]
        );
    };

    const handleSelectAll = () => {
        if (currentData.every(row => selectedRows.includes(row.id))) {
            setSelectedRows(selectedRows.filter(id => !currentData.some(row => row.id === id)));
        } else {
            setSelectedRows([...selectedRows, ...currentData.filter(row => !selectedRows.includes(row.id)).map(row => row.id)]);
        }
    };

    return (
        <div>
            <div className="table-container">
                <div className="table-header">
                    <p className="total-records">Total Records: {totalRecords}</p>
                </div>

                <table className="reusable-tds-table">
                    <thead>
                        {/* Header Row 1 */}
                        <tr>
                            <th rowSpan="2">
                                <input
                                    type="checkbox"
                                    checked={currentData.length > 0 && currentData.every(row => selectedRows.includes(row.id))}
                                    onChange={handleSelectAll}
                                />
                            </th>
                            {columns.map((col, index) =>
                                col.children ? (
                                    <th key={index} colSpan={col.children.length} className="header-main">{col.header}</th>
                                ) : (
                                    <th key={index} rowSpan="2" className="header-main">{col.header}</th>
                                )
                            )}
                        </tr>

                        {/* Header Row 2 */}
                        <tr>
                            {columns.map(col =>
                                col.children
                                    ? col.children.map((child, idx) => (
                                        <th key={`${col.header}-${idx}`} className="header-sub">{child.header}</th>
                                    ))
                                    : null
                            )}
                        </tr>
                    </thead>

                    <tbody>
                        {dataLoading ? (
                            <tr>
                                <td colSpan={columns.length + 1}>
                                    <div className="loading-container">
                                        <div className="spinner-border text-primary mb-3" role="status"></div>
                                        <p className="loading-text">Loading...</p>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            currentData.map((row, index) => (
                                <tr key={index}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={selectedRows.includes(row.id)}
                                            onChange={() => handleRowSelect(row.id)}
                                        />
                                    </td>
                                    {columns.map(col =>
                                        col.children
                                            ? col.children.map((child, idx) => (
                                                <td key={`${col.header}-${idx}`}>{row[child.accessor]}</td>
                                            ))
                                            : <td key={col.accessor}>{row[col.accessor]}</td>
                                    )}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <div className="table-controls">
                {isCustomOpen && (
                    <>
                        <button onClick={handleCSVDownload} className="download-button">DATA DOWNLOAD</button>
                        <button onClick={() => setIsModalOpen(true)} className="open-modal-button">CUSTOMIZE TABLE</button>
                        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                            <ColumnSelector
                                columns={columns}
                                selectedColumns={selectedColumns}
                                onColumnChange={handleColumnChange}
                            />
                        </Modal>
                    </>
                )}

                <div className="pagination-container">
                    <ReactPaginate
                        previousLabel="previous"
                        nextLabel="next"
                        breakLabel="..."
                        breakClassName="break-me"
                        pageCount={Math.ceil(totalRecords / itemsPerPage)}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName="pagination"
                        activeClassName="active"
                    />
                </div>
            </div>

            {loading && (
                <div className="overlay-loader">
                    <div className="spinner-border text-primary mb-3" role="status"></div>
                    <p className="loading-text">Downloading files...</p>
                </div>
            )}
        </div>
    );
};

export default TableForTDS;
